import { httpPost, httpDownload } from '../../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL, REPORT_COLUMN_MODULE, RECHARGING_TAB_TYPE } from '../../../../constants/external-constants';

import {
    getRechargingInventory,
    setRechargingInventoryError,
    setRechargingInventoryColSearchStr,
    sortRechargingInventoryItems,
    setRechargingInventoryPageSize,
    setRechargingInventoryFilter,
    applyRechargingInventoryFilter,
    applyRechargingInventoryStatusFilter,
    applyRechargingInventoryTabFilter,
    setDefaultRechargingInventory,
    setRechargingInventoryLoading
} from "../../../../constants/model-reducers/external/recharge/recharging-inventory/recharging-inventory.settings";
import { convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';

const defaultState = () => ({
    isRechargingInventoryLoaded: false,
    isRechargingInventoryError: false,
    rechargingInventoryItems: DEFAULT_TABLE_RESULT_MODEL,
    rechargingInventoryColSort: '',
    rechargingInventoryIsSortedAsc: false,
    rechargingInventoryTableFilterList: [],
    rechargingInventoryTableFilterApply: false,
    rechargingInventoryStatusFilterList: [],
    rechargingInventoryTableFilterStatusApply: 0,
    rechargingInventoryTableFilterTabApply: 0,
});

const initialState = defaultState();

export const rechargingInventoryActions = {
    setDefaultRechargingInventory: () => async (dispatch, state) => {
        dispatch({
            type: setDefaultRechargingInventory,
            inventoryItems: DEFAULT_TABLE_RESULT_MODEL
        });
    },
    getRechargingInventory: (pageIndex = 0) => async (dispatch, state) => {
        const { Headers, Pagination } = state().rechargingInventory.rechargingInventoryItems;
        const {
            rechargingInventoryIsSortedAsc,
            rechargingInventoryColSort,
            rechargingInventoryTableFilterList,
            rechargingInventoryTableFilterApply,
            rechargingInventoryStatusFilterList,
            rechargingInventoryTableFilterStatusApply,
            rechargingInventoryTableFilterTabApply
        } = state().rechargingInventory;
    
        const userId = sessionStorage.getItem('UserID');
    
        try {
            const data = {
                PageFilter: {
                    PageIndex: pageIndex ?? 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: rechargingInventoryColSort,
                IsSortAscending: rechargingInventoryIsSortedAsc,
                TableFilterList: rechargingInventoryTableFilterList,
                ApplyFilter: rechargingInventoryTableFilterApply,
                StatusFilter: rechargingInventoryStatusFilterList,
                ApplyStatusFilter: rechargingInventoryTableFilterStatusApply,
                ApplyTabFilter: rechargingInventoryTableFilterTabApply
            };
    
            let rechargingInventoryItems = await httpPost('external/recharge/getRechargingInventoryItems', data);
        
            dispatch({
                type: getRechargingInventory,
                rechargingInventoryItems: Object.keys(rechargingInventoryItems).length > 0
                    ? rechargingInventoryItems
                    : DEFAULT_TABLE_RESULT_MODEL,
                isRechargingInventoryLoaded: true,
                isRechargingInventoryError: false
            });
    
        } catch (e) {
            dispatch({
                type: setRechargingInventoryError,
                isRechargingInventoryError: true,
                isRechargingInventoryLoaded: false
            });
        }
    }
    ,
    setRechargingInventoryColSearchStr: (event, key) => async (dispatch, state) => {
        const val = event.target.value;
        const { rechargingInventoryItems, rechargingInventoryTableFilterTabApply } = state().rechargingInventory;

        const updatedHeaders = {
            ...rechargingInventoryItems.Headers,
            [key]: {
                ...rechargingInventoryItems.Headers[key],
                searchString: val
            }
        };

        const isTabAll = parseInt(rechargingInventoryTableFilterTabApply) === 0;

        const cloneAndSet = (keysToUpdate) => {
            keysToUpdate.forEach((typeKey) => {
                if (rechargingInventoryItems.Headers[typeKey]) {
                    updatedHeaders[typeKey] = {
                        ...rechargingInventoryItems.Headers[typeKey],
                        searchString: val
                    };
                }
            });
        };

        if (isTabAll) {
            switch (key) {
                case "InventoryNumber":
                    cloneAndSet(["CircuitNumber", "EquipmentNumber", "OTCNumber"]);
                    break;
                case "InventoryType":
                    cloneAndSet(["CircuitType", "EquipmentType", "OTCType"]);
                    break;
                case "InventoryDDI":
                    cloneAndSet(["CircuitDDI", "EquipmentDDI", "OTCDDI"]);
                    break;
                case "InventoryDateStr":
                    cloneAndSet(["InstallDateStr", "DeliveryDateStr", "ActivationDateStr"]);
                    break;
                default:
                    break;
            }
        }

        const rechargingInventoryItemsUpd = {
            ...rechargingInventoryItems,
            Headers: updatedHeaders
        };

        dispatch({
            type: setRechargingInventoryColSearchStr,
            data: rechargingInventoryItemsUpd,
            isRechargingInventoryError: false,
            isRechargingInventoryLoaded: true
        });
    },
    sortRechargingInventoryItems: (columnClicked, isSortedAsc) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().rechargingInventory.rechargingInventoryItems.Pagination;
        const { rechargingInventoryItems,
                rechargingInventoryTableFilterList, 
                rechargingInventoryTableFilterApply, 
                rechargingInventoryStatusFilterList, 
                rechargingInventoryTableFilterStatusApply,
                rechargingInventoryTableFilterTabApply } = state().rechargingInventory;

        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: rechargingInventoryItems.Pagination.PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...rechargingInventoryItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: rechargingInventoryTableFilterList,
            ApplyFilter: rechargingInventoryTableFilterApply,
            StatusFilter: rechargingInventoryStatusFilterList,
            ApplyStatusFilter: rechargingInventoryTableFilterStatusApply,
            ApplyTabFilter: rechargingInventoryTableFilterTabApply,
        };
        var resRechargingInventoryItems = await httpPost('external/recharge/getRechargingInventoryItems', data);
        if (resRechargingInventoryItems.ok === false) {
            dispatch({
                type: setRechargingInventoryError,
                isRechargingInventoryError: true,
                isRechargingInventoryLoaded: false
            });
        } else {
            dispatch({
                type: sortRechargingInventoryItems,
                rechargingInventoryItems: Object.keys(resRechargingInventoryItems).length > 0 ? resRechargingInventoryItems : DEFAULT_TABLE_RESULT_MODEL,
                rechargingInventoryColSort: columnClicked,
                rechargingInventoryIsSortedAsc: isSortedAsc,
                isRechargingInventoryLoaded: true
            });
        }
    },

    resizeRechargingInventoryPage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setRechargingInventoryPageSize,
            pageSize: parseInt(pageSize),
        });
    },

    extractRechargingInventory: () => async (dispatch, state) => {
        const { Headers } = state().rechargingInventory.rechargingInventoryItems;
        const { rechargingInventoryIsSortedAsc,
                rechargingInventoryColSort, 
                rechargingInventoryTableFilterList, 
                rechargingInventoryTableFilterApply, 
                rechargingInventoryStatusFilterList, 
                rechargingInventoryTableFilterStatusApply, 
                rechargingInventoryTableFilterTabApply } = state().rechargingInventory;

        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;
        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        var filenameFilteredWithTab = rechargingInventoryTableFilterTabApply === RECHARGING_TAB_TYPE.circuit.id ? RECHARGING_TAB_TYPE.circuit.name :
                                      rechargingInventoryTableFilterTabApply === RECHARGING_TAB_TYPE.equipment.id ? RECHARGING_TAB_TYPE.equipment.name : 
                                      rechargingInventoryTableFilterTabApply === RECHARGING_TAB_TYPE.otc.id ? RECHARGING_TAB_TYPE.otc.name : RECHARGING_TAB_TYPE.all.name;
        var filename = `ATEM ${dealName} ${filenameFilteredWithTab} Recharging Inventory Extract – ${formattedTimeZoneDate}`;

        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: rechargingInventoryColSort,
            IsSortAscending: rechargingInventoryIsSortedAsc,
            FileName: filename,
            TableFilterList: rechargingInventoryTableFilterList,
            ApplyFilter: rechargingInventoryTableFilterApply,
            StatusFilter: rechargingInventoryStatusFilterList,
            ApplyStatusFilter: rechargingInventoryTableFilterStatusApply,
            ApplyTabFilter: rechargingInventoryTableFilterTabApply,
        };

        httpDownload('external/recharge/getAllExtractRechargingInventoryItems', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    addRechargingInventoryFilter: (tableFilter) => (dispatch, state) => {
        const { rechargingInventoryTableFilterList } = state().rechargingInventory;

        var filterList = [...rechargingInventoryTableFilterList, tableFilter];

        dispatch({
            type: setRechargingInventoryFilter,
            filterList: filterList
        })
    },

    removeRechargingInventoryFilter: (removeIndex) => (dispatch, state) => {
        const { rechargingInventoryTableFilterList } = state().rechargingInventory;

        var filterList = rechargingInventoryTableFilterList.filter((item, index) => {
            return index !== removeIndex;
        });

        dispatch({
            type: setRechargingInventoryFilter,
            filterList: filterList
        })
    },

    applyRechargingInventoryFilter: (isApply) => (dispatch, state) => {
        const { rechargingInventoryTableFilterList } = state().rechargingInventory;

        dispatch({
            type: applyRechargingInventoryFilter,
            applyFilter: isApply,
            filterList: isApply ? rechargingInventoryTableFilterList : []
        });
    },
    applyRechargingInventoryStatusFilter: (isStatusApply) => (dispatch, state) => {

        dispatch({
            type: applyRechargingInventoryStatusFilter,
            applyStatusFilter: isStatusApply,
        });
    },
    applyRechargingInventoryTabFilter: (isTabApply) => async (dispatch, state) => {
        dispatch({
            type: applyRechargingInventoryTabFilter,
            applyTabFilter: isTabApply,
        });
        await new Promise(resolve => setTimeout(resolve, 500));
        dispatch({
            type: setRechargingInventoryError,
            isRechargingInventoryError: true,
            isRechargingInventoryLoaded: false
        });
    },
    setRechargingInventoryLoading: (setLoad = false) => (dispatch, state) => {
        dispatch({
            type: setRechargingInventoryLoading,
            isRechargingInventoryLoaded: setLoad
        });
    },
    saveRechargingInventoryCustomCols: (selectedCols) => async (dispatch, state) => {
        const { Headers, Pagination } = state().rechargingInventory.rechargingInventoryItems;
        const { rechargingInventoryIsSortedAsc,
                rechargingInventoryColSort, 
                rechargingInventoryTableFilterList, 
                rechargingInventoryTableFilterApply, 
                rechargingInventoryStatusFilterList, 
                rechargingInventoryTableFilterStatusApply, 
                rechargingInventoryTableFilterTabApply } = state().rechargingInventory;

        try {
            var userId = sessionStorage.getItem('UserID');
            var reportColumnModuleFilteredWithTab = rechargingInventoryTableFilterTabApply === RECHARGING_TAB_TYPE.circuit.id ? REPORT_COLUMN_MODULE.CircuitRechargeManagement :
                                                    rechargingInventoryTableFilterTabApply === RECHARGING_TAB_TYPE.equipment.id ? REPORT_COLUMN_MODULE.EquipmentRechargeManagement : 
                                                    rechargingInventoryTableFilterTabApply === RECHARGING_TAB_TYPE.otc.id ? REPORT_COLUMN_MODULE.OTCRechargeManagement : REPORT_COLUMN_MODULE.RechargingInventoryRechargeManagement;

            var customizeFormData = {
                UserId: parseInt(userId),
                ReportColumnModule: reportColumnModuleFilteredWithTab,
                SelectedCols: selectedCols
            };

            await httpPost('external/recharge/saveRechargingInventoryCustomizeColumns', customizeFormData);

            dispatch({
                type: setRechargingInventoryError,
                isRechargingInventoryError: true,
                isRechargingInventoryLoaded: false
            });

            var data = {
                PageFilter: {
                    PageIndex: 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: rechargingInventoryColSort,
                IsSortAscending: rechargingInventoryIsSortedAsc,
                TableFilterList: rechargingInventoryTableFilterList,
                ApplyFilter: rechargingInventoryTableFilterApply,
                StatusFilter: rechargingInventoryStatusFilterList,
                ApplyStatusFilter: rechargingInventoryTableFilterStatusApply,
                ApplyTabFilter: rechargingInventoryTableFilterTabApply,
            };

            var rechargingInventoryItems = await httpPost('external/recharge/getRechargingInventoryItems', data);

            dispatch({
                type: getRechargingInventory,
                rechargingInventoryItems: Object.keys(rechargingInventoryItems).length > 0 ? rechargingInventoryItems : DEFAULT_TABLE_RESULT_MODEL,
                isRechargingInventoryLoaded: true,
                isRechargingInventoryError: false
            });
        }
        catch (e) {
            dispatch({
                type: setRechargingInventoryError,
                isRechargingInventoryError: true,
                isRechargingInventoryLoaded: false
            });
        }
    },
    mapRechargingInventory: (uploadTypeId) => async (dispatch, state) => {
        try {
            const userId = sessionStorage.getItem('UserID');
            const {
                rechargingInventoryTableFilterApply,
                rechargingInventoryStatusFilterList,
                rechargingInventoryTableFilterStatusApply,
                rechargingInventoryTableFilterTabApply,
                rechargingInventoryTableFilterList } = state().rechargingInventory;

            var data = {
                ApplyFilter: rechargingInventoryTableFilterApply,
                StatusFilter: rechargingInventoryStatusFilterList,
                ApplyStatusFilter: rechargingInventoryTableFilterStatusApply,
                ApplyTabFilter: rechargingInventoryTableFilterTabApply,
                TableFilterList: rechargingInventoryTableFilterList,
            };

            const result = await httpPost(`external/recharge/rechargingInventoryBulkMapping/` + userId + `/` + uploadTypeId, data);
            return result;
        } catch (e) {
            return e;
        }
    },
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getRechargingInventory:
            return {
                ...state,
                rechargingInventoryItems: action.rechargingInventoryItems,
                isRechargingInventoryLoaded: action.isRechargingInventoryLoaded,
                isRechargingInventoryError: action.isRechargingInventoryError
            };
        case setRechargingInventoryError:
            return {
                ...state,
                isRechargingInventoryError: action.isRechargingInventoryError,
                isRechargingInventoryLoaded: action.isRechargingInventoryLoaded
            }
        case setRechargingInventoryColSearchStr:
            return {
                ...state,
                rechargingInventoryItems: action.data,
                isRechargingInventoryLoaded: action.isRechargingInventoryLoaded,
                isRechargingInventoryError: action.isRechargingInventoryError
            }
        case sortRechargingInventoryItems:
            return {
                ...state,
                rechargingInventoryItems: action.rechargingInventoryItems,
                rechargingInventoryColSort: action.rechargingInventoryColSort,
                rechargingInventoryIsSortedAsc: action.rechargingInventoryIsSortedAsc,
                isRechargingInventoryLoaded: action.isRechargingInventoryLoaded
            }
        case setRechargingInventoryPageSize:
            return {
                ...state,
                rechargingInventoryItems: {
                    ...state.rechargingInventoryItems,
                    Pagination: {
                        ...state.rechargingInventoryItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setRechargingInventoryFilter:
            return {
                ...state,
                rechargingInventoryTableFilterList: action.filterList
            }
        case applyRechargingInventoryFilter:
            return {
                ...state,
                rechargingInventoryTableFilterApply: action.applyFilter,
                rechargingInventoryTableFilterList: action.filterList
            }
        case applyRechargingInventoryStatusFilter:
            return {
                ...state,
                rechargingInventoryTableFilterStatusApply: action.applyStatusFilter,
            }
        case applyRechargingInventoryTabFilter:
            return {
                ...state,
                rechargingInventoryTableFilterTabApply: action.applyTabFilter,
            }
        case setRechargingInventoryLoading:
            return {
                ...state,
                isRechargingInventoryLoaded: action.isRechargingInventoryLoaded
            }
        case setDefaultRechargingInventory:
            return initialState;
        default:
            return state;
    }
};